const privilegedProjectTabs = [
    "Metadata Config",
    "Merge Config",
    "Mapping Config",
    "Packages",
    "Translation Table",
    "Theme",
];

export const getProjectTabs = ({ canManageProject, hasProject }) => {
    const tabs = ["Project", "Fiscal Year"];

    if (canManageProject) {
        tabs.push(...privilegedProjectTabs);
    }

    if (canManageProject && hasProject) {
        tabs.push("Run Scripts");
    }

    return tabs;
};
